import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { QuoteRequestTemplatePage } from '@/areas/quote-requests/QuoteRequestTemplates/QuoteRequestTemplatesPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/templates/quote-request/')({
    staticData: { access: { permissions: ['view:sourcing'] }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <QuoteRequestTemplatePage />;
}
